import React from "react"
import styled from "styled-components"
import { Helmet } from "react-helmet-async"
import Layout from "../ui/Layout"
import NavMain from "../app/NavMain"
import ScrollablePage from "../ui/ScrollablePage"
import Paper from "../ui/Paper"
import { Header, Overview } from "../ui/PageHeader"

const Container = styled(Paper)`
  padding: 3rem;
`

/** NotFound is a default route when no other matches */
const NotFound = () => {
  return (
    <Layout>
      <NavMain key="nav-left" />
      <Helmet>
        <title>Not Found - Astrosite</title>
      </Helmet>
      <ScrollablePage>
        <Header>
          <Overview>
            <h1>404 Not found</h1>
          </Overview>
        </Header>
        <Container>
          <p>The page you&apos;re looking for does not exist.</p>
        </Container>
      </ScrollablePage>
    </Layout>
  )
}

export default NotFound
